import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim();
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY?.trim();
const localDemoAuthOptIn = import.meta.env.VITE_ENABLE_LOCAL_DEMO_AUTH === 'true';

function isExplicitLocalDevRuntime() {
  if (!import.meta.env.DEV || typeof window === 'undefined') return false;

  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);
export const isLocalDemoAuthEnabled = !isSupabaseConfigured && localDemoAuthOptIn && isExplicitLocalDevRuntime();
export const authConfigurationErrorMessage = 'Вход недоступен: аутентификация не настроена для этой сборки. Обратитесь к администратору.';

/**
 * Null when Supabase env vars are absent.
 * All call sites are already gated by `isSupabaseConfigured` — use `requireSupabase()` there.
 */
export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(supabaseUrl!, supabaseAnonKey!)
  : null;

/**
 * Returns the Supabase client, throwing a clear configuration error if it was
 * never constructed. Always call this inside a block already guarded by
 * `isSupabaseConfigured` so the throw is unreachable at runtime.
 */
export function requireSupabase(): SupabaseClient {
  if (!supabase) {
    throw new Error(
      '[Кворум] Supabase client is not configured. ' +
        'Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY before calling this function.',
    );
  }
  return supabase;
}

